import { createGlobalState } from '@vueuse/core'
import { getDatabase, ref } from "firebase/database";
import { reactive, ref as refVue } from 'vue'
import { getFirestore, doc, setDoc, collection, runTransaction  } from "firebase/firestore";
import { realtimeDatabase  } from "~/services/firebaseInstance";


export const useFirebaseXtable = createGlobalState(
    () => {
        // state
        const storeId = refVue('')

        // getters
        // const doubleCount = computed(() => count.value * 2)

        // actions
        function setStoreId(id = '') {
            storeId.value = id;
        }


        function jobchainRef() {
            const db = realtimeDatabase;

            return ref(db, `stores/${storeId.value}/jobchain`);
        }

        function itemsRef() {
            const db = realtimeDatabase;

            return ref(db, `stores/${storeId.value}/items`);
        }

        function qrcodeRef() {
            const db = realtimeDatabase;

            return ref(db, `stores/${storeId.value}/qrcode`);
        }

        function summaryRef() {
            const db = realtimeDatabase;

            return ref(db, `stores/${storeId.value}/summary`);
        }

        function tablesRef() {
            const db = realtimeDatabase;

            return ref(db, `stores/${storeId.value}/tables`);
        }

        function tableStateRef() {

            const db = realtimeDatabase;

            return ref(db, `stores/${storeId.value}/tableState`);
        }

        function receiptsRef() {
            const db = realtimeDatabase;

            return ref(db, `stores/${storeId.value}/receipts`);
        }

        function productsRef() {
            const db = realtimeDatabase;

            return ref(db, `stores/${storeId.value}/products`);
        }

        function handshakeRef() {
            const db = realtimeDatabase;

            return ref(db, `stores/${storeId.value}/handshake`);
        }

        function jobRequestRef() {

            const db = realtimeDatabase;

            return ref(db, `stores/${storeId.value}/jobRequest`);
        }

        function settingsRef() {

            const db = realtimeDatabase;

            return ref(db, `stores/${storeId.value}/settings`);
        }

        function employeesRef() {

            const db = realtimeDatabase;

            return ref(db, `stores/${storeId.value}/employees`);
        }

        function qrcodeOrdersRef() { 
            const db = realtimeDatabase;

            return ref(db, `stores/${storeId.value}/qrcode_orders`);
        }
      



        return {
            storeId,
            setStoreId,
            jobchainRef,
            itemsRef,
            receiptsRef,
            qrcodeRef,
            summaryRef,
            tablesRef,
            tableStateRef,
            productsRef,
            handshakeRef,
            jobRequestRef,
            settingsRef,
            employeesRef,
            qrcodeOrdersRef,
            getStoreId : () => storeId.value
        }
    }
)


export const useFirestoreXtable = createGlobalState(

    () => {
        // state
        const storeId = refVue(null)


        return {
            getStoreid: () => storeId.value,
            setStoreId,
            addDayJobs,
            addTransaction,
            storeCollectionRef,
            collectionRef,
            collectionDocIdRef,
            collectionBetaWhiteList,
            subCollectionRef,
            subCollectionDocIdRef,
        }
        function setStoreId(id) {
            storeId.value = id;
        }

        async function addTransaction(_ref, data, cancelCallback){
            const db = getFirestore();
            await runTransaction(db, async (transaction) => { 
                cancelCallback && cancelCallback()
                transaction.set(_ref, data)
            })
            
        }

        function addDayJobs(docId, data) {
            const db = getFirestore();
            const docRef = doc(db, "stores", storeId.value, 'jobs', docId);
            return setDoc(docRef, data);
        }

        function storeCollectionRef() {
            const db = getFirestore();
            const ref  = doc(db, `stores/${storeId.value}`);
            return ref;
        }        

        function collectionRef(collectionName) {
            const db = getFirestore();
            const collectionRef  = collection(db, collectionName  );
            return collectionRef;
        }

        function collectionDocIdRef(collectionName, docId) {
            const db = getFirestore();
            const docRef = doc(db, collectionName, docId);
            return docRef;
        }

        function subCollectionRef (subCollectionName : string) {
            const db = getFirestore();
            const collectionRef  = collection(db, `stores/${storeId.value}/${subCollectionName}`);
            return collectionRef;
        }


        function subCollectionDocIdRef (subCollectionName : string, docId : string) {
            const db = getFirestore();
            const docRef = doc(db, `stores/${storeId.value}/${subCollectionName}`, docId);
            return docRef;
        }
        function collectionBetaWhiteList() {
            const db = getFirestore();
            const docRef = doc(db, "beta_whitelist", storeId.value);
            return docRef;
        }        
        
    }
)

 
